import { Link, useTranslate } from 'react-admin';
import { matchPath, Outlet, useLocation } from 'react-router-dom';
import { FavoriteBorder } from '@mui/icons-material';
import { Badge, Box, IconButton, Tab, Tabs, Tooltip } from '@mui/material';
import { ICONS_BY_OBJECT, OBJECTS_TYPES } from './constants';

const OBJECTS: string[] = [
	OBJECTS_TYPES.APARTMENTS,
	OBJECTS_TYPES.OFFICES,
	OBJECTS_TYPES.BUILDINGS,
	OBJECTS_TYPES.COMMERCES,
	OBJECTS_TYPES.COMPLEXES
];

export const MainPage = () => {
	const { pathname } = useLocation();
	const match = matchPath({ path: 'objects/:type' }, pathname);
	const translate = useTranslate();

	if (!match) {
		return null;
	}

	const { params } = match;

	return (
		<>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					borderBottom: 1,
					borderColor: 'divider'
				}}
			>
				<Tabs value={params.type}>
					{OBJECTS.map((objectType: string) => {
						const Icon = ICONS_BY_OBJECT[objectType];

						return (
							<Tab
								key={objectType}
								icon={<Icon fontSize="small" />}
								iconPosition="start"
								label={translate(`objects.items.${objectType}`)}
								value={objectType}
								to={`/objects/${objectType}`}
								component={Link}
							/>
						);
					})}
				</Tabs>
				<Tooltip title="Обране">
					<IconButton component={Link} to="/objects/favorites">
						<Badge badgeContent={1} color="error">
							<FavoriteBorder />
						</Badge>
					</IconButton>
				</Tooltip>
			</Box>
			<Outlet />
		</>
	);
};
